import { number, object, SchemaOf } from 'yup'

export interface VatDeclarationsDefinePeriodPayoutModalForm {
  amount: number
}

export type VatDeclarationsDefinePeriodPayoutModalFormSchema = SchemaOf<VatDeclarationsDefinePeriodPayoutModalForm>

export const getValidationSchema = (): VatDeclarationsDefinePeriodPayoutModalFormSchema =>
  object({
    amount: number().required(),
  })

export const defaultValues: VatDeclarationsDefinePeriodPayoutModalForm = {
  amount: 0,
}
